<template>
  <div>
    <CardContainer>
      <CommonForm slot="header" @search="formSearch" :form-json="formjson" />
      <CommonTable
        ref="table"
        width="100"
        :data="tableData"
        :total="total"
        :needIndex="true"
        @change="handleTableChange"
        :operation="operation"
        @operation="handleOperation"
        :table-json="tablejson"
      >
      </CommonTable>
    </CardContainer>
  </div>
</template>

<script>
import formjson from './Model/Formjson.Index'
import tablejson from './Model/Tablejson.Index'
import formTableMixin from '@manage/mixins/formTableMixin'
export default {
  mixins: [formTableMixin],
  data() {
    return {
      formjson,
      tablejson,
      operation: [
        {
          name: '查看设备',
          type: 'detail'
        }
      ],
      queryApi: this.$api.freezer.alarm_list,
      row: {}
    }
  },
  methods: {
    formSearch(data) {
      let params = { ...data }
      params.devType = '01' // 01冷柜 02红酒柜
      params.excType = '01' // 01预警 02故障
      this.search(params, null, this.queryApi)
    },
    handleDetail(row) {
      this.$router.push(
        '/freezer/list/detail?id=' +
          row.deviceId +
          '&assetNumber=' +
          row.assetNumber +
          '&room=' +
          row.room +
          '&assetId=' +
          row.assetId
      )
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'detail':
          this.handleDetail(row)
          break
      }
    }
  }
}
</script>
<style lang="less"></style>
